export default "__VITE_ASSET__CADHSzBi__"